import React from 'react';
import '../../styles/admin/production/JobStatusBadge.css';

const JobStatusBadge = ({ status }) => {
  const statusConfig = {
    to_schedule: { label: 'À planifier', className: 'status-to-schedule' },
    scheduled: { label: 'Planifié', className: 'status-scheduled' },
    in_progress: { label: 'En cours', className: 'status-in-progress' },
    completed: { label: 'Terminé', className: 'status-completed' },
    paused: { label: 'En pause', className: 'status-paused' },
    cancelled: { label: 'Annulé', className: 'status-cancelled' }
  };

  const config = statusConfig[status] || { label: status, className: 'status-default' };

  return (
    <span className={`job-status-badge ${config.className}`}>
      {config.label}
    </span>
  );
};

export default JobStatusBadge;